import { InputByTypeProperties } from "@/models/form-builder-interface";
import { ConfirmableFieldAlias } from "@/models/field-confirmation-interface";

export type ConfirmationMode = true | false | 'optional' | 'if-filled';

export interface RegisterMemberProps {
  id?: string;
  profileFields?: string[];
  fieldTitles?: Record<string, string>;
  optionalFields?: string[];
  inputProperties?: InputByTypeProperties;
  forceFields?: Record<string, string>;
  otpConfirm?: Partial<Record<ConfirmableFieldAlias, ConfirmationMode>>;
  /** If true, OTP is sent first then uniqueness is checked (legacy). If false/absent (default), uniqueness is checked before OTP. */
  legacyOtpFlow?: boolean;
  languageMode?: 'hidden_no_api' | 'hidden_auto' | 'editable_auto';
  /** Raw text shown while resend timer is counting. Use {0} as placeholder for seconds. Defaults to localized string. */
  textRetryIn?: string;
  /** Raw text for the resend link shown after timer ends. Defaults to localized string. */
  textRetryNow?: string;
}

export const defaults = {
  profileFields: ['firstname', 'lastname', 'birth_date', 'country_id', 'region_id', 'email', 'password', 'password_confirm'],
  inputProperties: { noAutocomplete: true },
  legacyOtpFlow: false,
  languageMode: 'hidden_no_api' as const,
};
